import React, { useEffect, useRef } from 'react';
import { useTourSearchStore } from '../../store/TourSearchStore';
import TourSearchResults from './TourSearchResults';
import { useLocation } from 'react-router-dom';
export default function TourSearchResultsContainer({ hideHeader = false, forceDocumentNavigation = false, newTourSearch = false, suppressInitialSpinner = false, hideWhileLoading = false, onInitialSearchStart, onSearchResultReady, forceSearchKey = 0, forceSearchQuery, groupBy = 'tour', variant = 'default' }) {
    const [_, actions] = useTourSearchStore();
    const { search } = useLocation();
    const initialSearchStarted = useRef(false);
    useEffect(() => {
        if (!initialSearchStarted.current) {
            initialSearchStarted.current = true;
            if (!forceSearchKey)
                onInitialSearchStart === null || onInitialSearchStart === void 0 ? void 0 : onInitialSearchStart();
        }
        const normalizedSearch = search.replace(/^\?/, '');
        const normalizedForceSearch = (forceSearchQuery !== null && forceSearchQuery !== void 0 ? forceSearchQuery : '').replace(/^\?/, '');
        if (forceSearchKey && normalizedSearch === normalizedForceSearch)
            return;
        if (newTourSearch)
            actions.searchNewTourURLParams(search);
        else
            actions.searchURLParams(search);
    }, [search, newTourSearch, forceSearchKey, forceSearchQuery]);
    useEffect(() => {
        if (!forceSearchKey)
            return;
        const query = forceSearchQuery !== null && forceSearchQuery !== void 0 ? forceSearchQuery : search;
        if (newTourSearch)
            actions.searchNewTourURLParams(query, true);
        else
            actions.searchURLParams(query, true);
    }, [forceSearchKey, forceSearchQuery, newTourSearch]);
    return React.createElement(TourSearchResults, { hideHeader: hideHeader, forceDocumentNavigation: forceDocumentNavigation, suppressInitialSpinner: suppressInitialSpinner, hideWhileLoading: hideWhileLoading, onSearchResultReady: onSearchResultReady, groupBy: groupBy, variant: variant });
}
